import { render } from "./ConferenceForm.vue?vue&type=template&id=691deb8c&scoped=true"
import script from "./ConferenceForm.vue?vue&type=script&lang=js"
export * from "./ConferenceForm.vue?vue&type=script&lang=js"

import "./ConferenceForm.vue?vue&type=style&index=0&id=691deb8c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-691deb8c"]])

export default __exports__